import { ReportAllocatedAndSubsidies41Component } from "../../../components/SupportSystem/Reports/ReportAllocatedAndSubsidies41Component";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NewReportAllocatedAndSubsidies41Component } from "../../../components/SupportSystem/Reports/NewReportAllocatedAndSubsidies41Component";


export function ReportAllocatedAndSubsidies41Container() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <NewReportAllocatedAndSubsidies41Component/>
            <Footer />
        </div>   
        // 
    )
    
}